const version = '1.0.8';

export default version;
